// import Swiper core, modules, and css
import Swiper from 'swiper';
import { Scrollbar, FreeMode } from 'swiper/modules'; // import Swiper modules (if needed). Full list here: https://swiperjs.com/swiper-api#modules

import './index.scss'

import { toggleSwiperLock } from './../../js/toggleSwiperLock'

class Tasting {
    constructor($el) {
        this.$el = $el
    }
    init() {
        const loadMoreButton = this.$el.querySelector(".acf-tasting__loadmore");
        const hiddenItems = this.$el.querySelectorAll(".acf-tasting__slide.hidden");
    
        if (loadMoreButton) {
            loadMoreButton.addEventListener("click", function() {
                hiddenItems.forEach(item => item.style.display = "block");
                loadMoreButton.style.display = "none"; // Cache le bouton après affichage
            });
        }
        let mobile = window.matchMedia('(max-width: 1024px)');
        // console.log(mobile.matches);
        
        this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
            slidesPerView: 'auto',
            speed: 1000,
            spaceBetween: 10, 
            grabCursor: true,
            init : mobile.matches,
            on: {
                init: function (swiper) {
                    toggleSwiperLock(swiper)
                },
                resize: function (swiper) {
                    toggleSwiperLock(swiper)
                }
            }
        })
        
        mobile.addEventListener('change', (e)=> {
            if(!e.matches) { //Now is Desktop
                this.swiper.disable();
                console.log('DESKTOP DESTROYED')
            } else {
                this.swiper.init();
                
                console.log("l'autre")
            }
        })
        
        // window.addEventListener('load', function() {swiperMode(this.$el)});
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-tasting') ].forEach($block => {
        $block.expandygg = new Tasting($block)
    })
}, {capture: false, passive: true, once: true} || false)
